export default {
  priv: 'pr_device_files',
  overviewTitle: 'Onderhoudsverslagen',
  detailTitle: 'Onderhoudsverslag',
  deleteTitle: 'dit onderhoudsverslag',
  url: '/devices/servicereports',
  apiUrl: '/deviceservicereports/',
  sortBy: ['file.name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'deviceservicereports',
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'str'
  },
  advancedSearchFields: [
    {
      text: 'Serienummer / Toestel',
      value: 'device_id',
      type: 'optionList',
      optionListName: 'devices'
    },
    {
      text: 'Periode van',
      value: 'date_start',
      type: 'date'
    },
    {
      text: 'Periode tot',
      value: 'date_end',
      type: 'date'
    },
    {
      text: 'Meetrapport gelinkt',
      value: 'linked_report',
      type: 'optionList',
      optionList: [
        {
          value: 'no',
          text: 'Nee'
        },
        {
          value: 'yes',
          text: 'Ja'
        }
      ]
    }
  ],
  tableFields: [
    {
      text: 'Naam',
      value: 'file.name',
      link: '/devices/servicereports/{id}',
      width: '20%'
    },
    {
      text: 'Datum',
      value: 'created_timestamp',
      width: '12.5%',
      filter: 'date'
    },
    {
      text: 'Ingegeven door',
      value: 'created_user_name',
      width: '12.5%'
    },
    {
      text: 'Toestel',
      value: 'device_serial_nr',
      link: '/devices/measuredevices/{device_id}',
      width: '15%'
    },
    {
      text: 'Meetrapport',
      value: 'devicereport_code',
      link: '/devices/measurereports/{devicereport_id}',
      width: '15%'
    },
    {
      // tslint:disable-next-line: quotemark
      text: "Aantal pagina's",
      value: 'nr_pages',
      width: '10%'
    }
  ]
};
